import { render, staticRenderFns } from "./sideList.vue?vue&type=template&id=6d7f85ee&scoped=true"
import script from "./sideList.vue?vue&type=script&lang=js"
export * from "./sideList.vue?vue&type=script&lang=js"
import style0 from "./sideList.vue?vue&type=style&index=0&id=6d7f85ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f85ee",
  null
  
)

export default component.exports